import * as ENUM_GLOBAL from '@/common/enum/forward/global'

export const ENUM_RE_YESNO = {
  [ENUM_GLOBAL.ENUM_YES_NO.YES]: { title: '是' },
  [ENUM_GLOBAL.ENUM_YES_NO.NO]: { title: '否' }
}
